'use client';

import type { BannerWithWhiteTextProps } from '@/core/types';

import React from 'react';

import { Box, Image, Button, Container, Typography } from '@/components/ui';

import { RouterLink } from '@/routes/components';

export default function BannerWithWhiteText({
  title,
  titleTag = 'h2',
  description,
  image,
  buttons,
  textMaxWidth = '',
  className = '',
}: BannerWithWhiteTextProps) {
  return (
    <div className={`${className} relative w-full`}>
      {!!image?.url && (
        <Image
          src={image?.url || ''}
          alt={image?.alt || ''}
          width={1920}
          height={800}
          objectFit="cover"
          className="w-full absolute top-0 left-0 h-full object-cover -z-[1]"
          loading="eager"
        />
      )}
      <Container className="flex items-center h-full relative z-10 min-h-[324px] md:min-h-[440px] lg:min-h-[540px] xl:min-h-[640px]">
        <Box className={`${textMaxWidth || 'max-w-[480px]'}`}>
          {title && (
            <Typography
              variant="h2"
              component={titleTag}
              className="text-[24px] text-white uppercase mb-[6px] md:mb-[28px] md:text-[42px]"
            >
              {title}
            </Typography>
          )}
          {description && (
            <Box
              className="text-sm md:text-[18px] text-white [&>p]:mb-4 [&>ul]:list-disc [&>ul]:pl-6 [&>ul]:mb-4"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
          {buttons && buttons.length > 0 && (
            <Box className="flex justify-start mt-2 lg:mt-8 gap-4">
              {buttons.map((button, index) => (
                <Button
                  key={index}
                  href={button.link}
                  component={RouterLink}
                  variant={button.variant}
                  className={`min-w-[171px] md:min-w-[180px] px-2 md:px-4 text-sm md:text-base ${button.className}`}
                >
                  {button.text}
                </Button>
              ))}
            </Box>
          )}
        </Box>
      </Container>
    </div>
  );
}
